module.exports = __webpack_public_path__ + "static/media/edit.a4d88dc2.svg";